import React from "react";
import styled from "styled-components";
import HIGDropdown from "@hig/dropdown";
import PropTypes from "prop-types";

const DropDown = ({
  className,
  placeholder,
  options,
  handleChange,
  value
}) => /*#__PURE__*/React.createElement(HIGDropdown, {
  className: className,
  variant: "box",
  placeholder: placeholder,
  options: options,
  onChange: handleChange,
  value: value
});

DropDown.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  handleChange: PropTypes.func,
  value: PropTypes.any
};
export default styled(DropDown)`
  > div > div > input {
    font-weight: 400;
    :focus {
      border: 1px solid #0696d7;
      box-shadow: 0 0 5px #0696d7;
    }
  }

  > div {
    max-height: 140px;
  }
  
  > div > div > div {
    height: 0px;
  }
`;